document.addEventListener('DOMContentLoaded', function () {
	// Find all placeholder elements with the class .component-campaigns
	const placeholderDivs = document.querySelectorAll('.component.origo.campaigns.banners');

	// If no elements are found, stop.
	if (placeholderDivs.length === 0) {
		// console.warn('No elements with class .component-campaigns found.');
		return;
	}

	// --- Helper function to perform fetch with a timeout ---
	function fetchWithTimeout(url, options = {}, timeout = 10000) { // Default timeout 10 seconds
		const controller = new AbortController();
		const signal = controller.signal;

		// Merge original options with the abort signal
		const fetchOptions = { ...options, signal };

		// Set a timeout. If it expires, abort the fetch request.
		const timeoutId = setTimeout(() => controller.abort(), timeout);

		return fetch(url, fetchOptions)
			.finally(() => clearTimeout(timeoutId)); // Always clear the timeout when the fetch promise settles (success, error, or abort)
	}

	// --- Helper function to perform fetch with retries ---
	function fetchWithRetries(url, options = {}, retries = 3, delay = 1000) { // Default 3 retries, 1 second initial delay
		return fetchWithTimeout(url, options)
			.then(response => {
				// Even after a successful fetch (no network/timeout error),
				// check if the HTTP status itself is an error (e.g., 404, 500).
				// We might consider retrying on 5xx errors or 429 (Too Many Requests)
				// For simplicity here, we'll just throw if !response.ok after fetchWithTimeout succeeds.
				if (!response.ok) {
					// Throw an error that includes the status, which will be caught below
					throw new Error(`HTTP status ${response.status}`);
				}
				return response; // Return the successful response for the next .then()
			})
			.catch(error => {
				// If there are retries left
				if (retries > 0) {
					return new Promise(resolve => setTimeout(resolve, delay))
						// Then recursively call fetchWithRetries again with one less retry and increased delay (exponential backoff)
						.then(() => fetchWithRetries(url, options, retries - 1, delay * 1.5)); // Increase delay for next attempt
				} else {
					// No retries left, throw the final error
					throw error;
				}
			});
	}

	placeholderDivs.forEach(placeholderDiv => {

		// Get the data attribute from the current placeholder element in the loop
		const displayLocation = placeholderDiv.dataset.displayLocation;
		const isPreview = placeholderDiv.dataset.preview;

		// If the current element doesn't have the data attribute, skip it or show an error
		if (!displayLocation) {
			// placeholderDiv.innerHTML = '<p>Er is een configuratiefout gevonden.</p>';
			return; // Move to the next element in the loop
		}

		// Construct the API URL using IDs from the current element
		let apiUrl;
		const baseUrl = origoBannersConfig.apiUrl;
		if (isPreview) {
			const urlParams = new URLSearchParams(window.location.search);
			apiUrl = `${baseUrl}/${displayLocation}?preview=true&campaign=${urlParams.get('campaign')}&entity_id=${origoBannersConfig.entity_id}`;
		} else {
			apiUrl = `${baseUrl}/${displayLocation}?entity_id=${origoBannersConfig.entity_id}`;
		}

		// Use the retry logic to fetch data
		fetchWithRetries(apiUrl, { cache: 'no-store' })
			.then(response => {
				// This .then is reached after fetchWithRetries successfully gets a response object (after potential retries)
				// Now parse the JSON
				return response.json();
			})
			.then(data => {
				// Data successfully fetched and parsed for this element
				let contentHtml = ''; // Variable to build the content HTMsL string (table or message)

				// Determine which image to use based on screen size
				let imageUrl = '';

				if (window.innerWidth <= 768 && data.mobile_image) { // Mobile breakpoint
					imageUrl = data.mobile_image;
				} else if (window.innerWidth <= 1024 && data.tablet_image) { // Tablet breakpoint
					imageUrl = data.tablet_image;
				} else if (data.desktop_image) { // Default to desktop if available
					imageUrl = data.desktop_image;
				}

				// Only proceed if an image URL was found
				if (imageUrl) {
					const link = data.options && data.options.link;
					const hasLink = link && link.href;
					const linkHref = hasLink ? link.href : '#';
					const linkRel = hasLink && link.rel ? `rel="${link.rel}"` : '';
					const linkTarget = hasLink && link.target ? `target="${link.target}"` : '';
					const linkTitle = hasLink && link.title ? `title="${link.title}"` : '';
					let buttonHtml = '';

					// --- Button Logic ---
					if (data.options && data.options.button) {
						const button = data.options.button;
						const buttonClasses = `component button button-${button.type} position-${button.position}`;

						buttonHtml = `<span class="${buttonClasses}">${button.title}</span>`;
					}

					// --- Image Alt Text ---
					const altText = data.name ? `banner-${data.name.toLowerCase()}` : 'campagne banners';

					// Combine the image and button inside a relatively positioned container.
					// The container itself will be an <a> tag if a link is available.
					if (hasLink) {
						contentHtml = `
						<a href="${linkHref}" ${linkRel} ${linkTarget} ${linkTitle} class="campaign-banner-container">
                            <img src="${imageUrl}" alt="${altText}">
                            ${buttonHtml}
                        </a>
                    `;
					} else {
						contentHtml = `
							<div class="campaign-banner-container">
								<img src="${imageUrl}" alt="${altText}">
									${buttonHtml}
							</div>
						`;
					}
				}

				// Set the generated HTML and clean up the placeholder
				placeholderDiv.innerHTML = contentHtml;
			})
			.catch(error => {
				console.error('Er is iets mis gegaan tijdens het ophalen van de campagne.');
			});
	});
});
